export default "__VITE_PUBLIC_ASSET__c8a001c3__"